import React from "react";
import { Provider } from "react-redux";
import { loadTiles } from "tsi-common-react/src/apps/product-compare/thunks";
import { ProductCompareTheme } from "tsi-common-react/src/constants";
import { isoWebPageURL } from "tsi-common-react/src/models/nominals";
import {
    ProductCompareGridCMSData,
    ProductSelectionGridCMSData,
} from "tsi-common-react/src/models/product-compare";
import { check } from "tsi-common-react/src/models/utils";
import { dynamicPlaceComponent } from "tsi-common-react/src/utils/react";
import { usePageURL } from "tsi-common-react/src/utils/urls";

import { reverse } from "@reactivated";

import { store } from "../store";

// Render ProductCompareGridBlocks
dynamicPlaceComponent(
    '[data-place-react="product-compare-grid"]',
    async (elem) => {
        const parsedData = check(
            ProductCompareGridCMSData.decode(
                JSON.parse(elem.dataset.cms || ""),
            ),
        );
        const loading = await store.dispatch(loadTiles(parsedData.products));
        if (!loadTiles.fulfilled.match(loading)) {
            return null;
        }
        const tiles = loading.payload;
        const { ProductCompareGrid } = await import(
            "tsi-common-react/src/apps/product-compare/containers/ProductCompareGrid"
        );
        const ProductCompareGridWrapper = () => {
            const financeLink = usePageURL("finance_link");
            const home = usePageURL("home");
            return (
                <ProductCompareGrid
                    header={parsedData.header}
                    basketLink={isoWebPageURL.wrap(reverse("basket:summary"))}
                    financingLink={financeLink || home}
                    tiles={tiles}
                    sizeAttributeOptionGroup={
                        parsedData.size_attribute_option_group
                    }
                    preselectedSize={parsedData.preselected_size}
                    theme={
                        parsedData.theme.theme || ProductCompareTheme.DEFAULT
                    }
                    showFirstAvailablePrice
                />
            );
        };
        return (
            <Provider store={store}>
                <ProductCompareGridWrapper />
            </Provider>
        );
    },
).catch(console.error);

// Render the product selection grid
dynamicPlaceComponent(
    '[data-place-react="product-selection-grid"]',
    async (elem) => {
        const parsedData = check(
            ProductSelectionGridCMSData.decode(
                JSON.parse(elem.dataset.cms || ""),
            ),
        );
        void store.dispatch(loadTiles(parsedData.products));
        const { ProductSelectionGrid } = await import(
            "tsi-common-react/src/apps/product-compare/containers/ProductSelectionGrid"
        );
        const ProductSelectionGridWrapper = () => {
            const financeLink = usePageURL("finance_link");
            const home = usePageURL("home");
            return (
                <ProductSelectionGrid
                    header={parsedData.header}
                    financingLink={financeLink || home}
                    productComparePageURL={
                        parsedData.product_compare_page?.url || null
                    }
                    sizeAttributeOptionGroup={
                        parsedData.size_attribute_option_group
                    }
                    preselectedSize={parsedData.preselected_size}
                    theme={
                        parsedData.theme.theme || ProductCompareTheme.DEFAULT
                    }
                    footer={parsedData.footer}
                    showSizeSelector={parsedData.show_size_selector}
                />
            );
        };
        return (
            <Provider store={store}>
                <ProductSelectionGridWrapper />
            </Provider>
        );
    },
).catch(console.error);
